import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import { customBlue, customGrey, customWhite } from "../../theme/palette";

export const isIpad = window.matchMedia("(max-width: 1024px)").matches;

export const styledTypo = {
  fontSize: isIpad ? "14px" : "18px",
};

export const styledTypography = {
  fontSize: isIpad ? "14px" : "16px",
  fontWeight: 800,
};

const circularPrimaryMicButtonStyles = {
  minWidth: 50,
  width: 50,
  height: 50,
  padding: 0,
  borderRadius: "50%",
  boxShadow: "none",
  backgroundColor: customBlue.primaryBlue,
  color: customWhite.main,
  borderStyle: "solid",
  borderTopWidth: "2px",
  borderLeftWidth: "2px",
  borderRightWidth: "2px",
  borderBottomWidth: "4px",
  borderTopColor: customBlue.primaryBlue,
  borderLeftColor: customBlue.primaryBlue,
  borderRightColor: customBlue.primaryBlue,
  borderBottomColor: customBlue.primaryDark,
  transition: "all 0.15s ease-in-out",
  "&::after": {
    display: "none",
    borderRadius: "50%",
  },
  "&:hover": {
    backgroundColor: customBlue.primaryHover,
    boxShadow: "none",
    borderTopColor: customBlue.primaryHover,
    borderLeftColor: customBlue.primaryHover,
    borderRightColor: customBlue.primaryHover,
    borderBottomColor: customBlue.primaryDark,
  },
  "&:active": {
    backgroundColor: customBlue.primaryDark,
    boxShadow: "none",
    borderTopColor: customBlue.primaryDark,
    borderLeftColor: customBlue.primaryDark,
    borderRightColor: customBlue.primaryDark,
    borderBottomColor: customBlue.primaryDark,
  },
  "&.Mui-disabled": {
    backgroundColor: customGrey.iconGrade,
    color: customWhite.main,
    borderTopColor: customGrey.iconGrade,
    borderLeftColor: customGrey.iconGrade,
    borderRightColor: customGrey.iconGrade,
    borderBottomColor: customGrey.iconGrade,
  },
} as const;

export const StyledMicIcon = styled(Button)(circularPrimaryMicButtonStyles);

export const StyledMicIcon2 = styled(Button)({
  ...circularPrimaryMicButtonStyles,
  minWidth: 40,
  width: 40,
  height: 40,
});
